import { BuyButtons, SalePrice, Drawer, VariantSku, formatMoney } from "./static.theme.js";

var AjaxDrawer = class extends Drawer {
  constructor() {
    super();
    this.loaded
  }

  get href() {
    if(this._href) return this._href;
    const url = new URL(this.getAttribute("href"), location);
    if(url.pathname.startsWith("/pages/")) {
      const searchParams = new URLSearchParams(url.search);
      searchParams.set("view", "drawer");
      url.search = searchParams.toString();
    }
    return url.toString();
  }

  async show() {
    if(!this.loaded) {
      this.getContent();
    }
    super.show();
  }

  async getContent() {
    const response = await fetch(this.href, {
      method: 'GET'
    });
    const responseText = await response.text();
    this.innerHTML = responseText;
  }

};

if (!window.customElements.get("ajax-drawer")) {
  window.customElements.define("ajax-drawer", AjaxDrawer);
}

var VpvVariantSku = class extends VariantSku {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    this.innerText = "";

    window.addEventListener("optionSelected", e => {
      this.updateText();
    });

    window.addEventListener("variant:change", e => {
      this.updateText();
    });

    // Reset on Vehicle Select
    window.addEventListener("vehicleSelected", e => {
      this.innerText = "";
    });
  }

  updateText() {
    const { remainingVariants } = window.__VPV.pdp;
    const selectedVariant = remainingVariants?.length === 1 ? remainingVariants[0] : null;
    const sku = selectedVariant?.sku;
    if (sku) {
      this.innerText = `${window.themeVariables.strings.sku} ${sku}`;
      this.hidden = false;
    } else {
      this.innerText = "";
    }
  }
};
if (!window.customElements.get("vpv-variant-sku")) {
  window.customElements.define("vpv-variant-sku", VpvVariantSku);
}

var VpvSalePrice = class extends SalePrice {
  constructor() {
    super();
  }

  getPriceRange(variants) {
    let minPrice, maxPrice;

    variants.forEach(variant => {
      const variantPrice = parseFloat(variant.price.amount) * 100;

      if (!minPrice || minPrice > variantPrice) minPrice = variantPrice;
      if (!maxPrice || maxPrice < variantPrice) maxPrice = variantPrice;
    });

    if(minPrice === maxPrice) return [`${minPrice}`];
    return [`${minPrice}`, `${maxPrice}`];
  }

  connectedCallback() {
    super.connectedCallback();

    var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

    window.addEventListener("optionSelected", e => {
      const variants = e.detail?.filteredVariants;

      if (!variants || variants.length == 0) return;

      const priceRange = this.getPriceRange(variants);

      const node = document.createRange().createContextualFragment(priceRange.length > 1 ? `From ${formatMoney(priceRange[0], currencyFormat)}` : formatMoney(priceRange[0], currencyFormat));
      this.lastChild.replaceWith(node);
    });

    window.addEventListener("optionsLoaded", e => {
      const variants = e.detail?.unfilteredVariants;

      if (!variants || variants.length == 0) return;

      const priceRange = this.getPriceRange(variants);

      const node = document.createRange().createContextualFragment(priceRange.length > 1 ? `From ${formatMoney(priceRange[0], currencyFormat)}` : formatMoney(priceRange[0], currencyFormat));
      this.lastChild.replaceWith(node);
    });

    window.addEventListener("variantSelected", e => {
      const { priceV2 } = e.detail;
      if (priceV2?.amount) {
        const node = document.createRange().createContextualFragment(formatMoney(priceV2.amount * 100, currencyFormat));
        this.lastChild.replaceWith(node);
      }
    });
  }
};
if (!window.customElements.get("vpv-sale-price")) {
  window.customElements.define("vpv-sale-price", VpvSalePrice);
}

var VpvBuyButtons = class extends BuyButtons {
  constructor() {
    super();

    this.formNode = this.parentNode;
    this.atcButtonNode = this.querySelector('button[type="submit"]');
    this.disableAtcButton();
    this.setVehicleProps();
    this.boundSoldOutButton = this.soldOutButton.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();

    window.addEventListener("vehiclePickerOpened", e => {
      // console.log('vehiclePickerOpened', e.detail)
      this.setAttribute("hidden", "");
    });

    window.addEventListener("vehiclePickerClosed", e => {
      // console.log('vehiclePickerOpened', e.detail)
      this.updateAtc();
      this.removeAttribute("hidden");
    });

    window.addEventListener("vehicleSelected", e => {
      //console.log('vehicleSelected', e.detail)
      this.setVehicleProps();
      this.removeAttribute("hidden");
    });

    window.addEventListener("optionsLoaded", e => {
      //console.log('optionsLoaded', e.detail)
      this.updateAtc();
    });

    window.addEventListener("optionSelected", e => {
      //console.log('optionSelected', e.detail)
      this.updateOrAddLineItem(`_${e.detail.option}`, e.detail.value);
      this.updateAtc();
    });

    window.addEventListener("variantSelected", e => {
      // Update product form variant ID & button text
      const newVariantId = e.detail.id;
      const variantIdInput = this.formNode.querySelector('input[name="id"]');
      if (variantIdInput) {
        variantIdInput.value = newVariantId;
      }

      this.updateAtc();
    });

  }

  updateAtc() {
    const { remainingVariants } = window.__VPV.pdp;
    const selectedVariant = remainingVariants?.length === 1 ? remainingVariants[0] : null;
    const atcTextNode = this.atcButtonNode.getAttribute("is") === "custom-button" ? this.atcButtonNode.firstElementChild : this.atcButtonNode;

    let productAvailable = false;
    remainingVariants?.forEach(variant => {
      if(variant.availableForSale) {
        productAvailable = true;
      }
    });

    if (!selectedVariant) {
      const variantIdInput = this.formNode.querySelector('input[name="id"]');

      if(variantIdInput){
        variantIdInput.value = "";
      }
    }

    if (!productAvailable) {
      let soldOutText = window.themeVariables?.strings?.soldOutButton || "Sold Out";
      if(this.getAttribute("sold-out-text")){
        soldOutText = this.getAttribute("sold-out-text");
      }
      atcTextNode.innerHTML = soldOutText;

      if(this.getAttribute("sold-out-popup") || this.getAttribute("sold-out-link")){
        this.enableSoldOutButton();
        this.atcButtonNode.classList.remove("button--subdued");
      }else{
        this.disableAtcButton();
        this.atcButtonNode.classList.add("button--subdued");
      }
    } else {
      atcTextNode.innerHTML = window.themeVariables?.strings?.addToCartButton || "Add to Cart";
      this.atcButtonNode.classList.remove("button--subdued");
      this.enableAtcButton();
    }
  }

  setVehicleProps() {
    if (!VehicleData.getSelectedVehicle()) return;
    const { make, model, year } = VehicleData.getSelectedVehicle();
    if (make && model && year) {
      this.updateOrAddLineItem("year", year);
      this.updateOrAddLineItem("model", model);
      this.updateOrAddLineItem("make", make);
    }
  }

  updateOrAddLineItem(propKey, propValue) {
    // Updates form line item prop inputs
    const propName = `properties[_vehicle_${propKey}]`;
    let propInput = this.formNode.querySelector(`input[name="${propName}"]`);
    if (propInput) {
      propInput.setAttribute("value", propValue);
    } else {
      propInput = document.createElement("input");
      propInput.setAttribute("type", "hidden");
      propInput.setAttribute("name", propName);
      propInput.setAttribute("value", propValue);
      this.formNode.prepend(propInput);
    }
  }

  soldOutButton(e) {
    if(this.getAttribute("sold-out-link")){
      e.preventDefault();
      e.stopPropagation();
      window.location.href = this.getAttribute("sold-out-link");
    }
  }

  enableSoldOutButton() {
    this.atcButtonNode.removeAttribute("disabled");
    if(this.getAttribute("sold-out-popup")){
      console.log("removeEventListener");
      this.atcButtonNode.setAttribute("type", "button");
      this.atcButtonNode.setAttribute("aria-controls", this.getAttribute("sold-out-popup"));
      this.atcButtonNode.removeEventListener("click", this.boundSoldOutButton);
    }else if (this.getAttribute("sold-out-link")) {
      console.log("addEventListener");
      this.atcButtonNode.setAttribute("type", "button");
      this.atcButtonNode.addEventListener("click", this.boundSoldOutButton);
    }
  }

  enableAtcButton() {
    this.atcButtonNode.removeAttribute("disabled");
    this.atcButtonNode.setAttribute("type", "submit");
    this.atcButtonNode.removeAttribute("aria-controls");
    this.atcButtonNode.removeEventListener("click", this.boundSoldOutButton);
  }

  disableAtcButton() {
    this.atcButtonNode.setAttribute("disabled", "");
    this.atcButtonNode.removeEventListener("click", this.boundSoldOutButton);
  }
};
if (!window.customElements.get("vpv-buy-buttons")) {
  window.customElements.define("vpv-buy-buttons", VpvBuyButtons);
}

export { VpvBuyButtons, VpvVariantSku, AjaxDrawer };


